import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index.vue'
import Map from '../components/Map.vue'
import List from '../components/List.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    { path: '/map/', component: Map, name: 'map', props: true},
    { path: '/list', component: List, name: 'list', props: true},
    { path: '*', component: { template: '<div>Not Found</div>'} }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js